import { API_ORIGIN } from './api';

/**
 * Resolve any image URL — absolute URLs are returned as-is,
 * relative paths from the backend get the configured API origin prepended.
 */
export const resolveImageUrl = (url) => {
  if (!url) return null;
  if (typeof url !== 'string') return null;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${API_ORIGIN}${path}`;
};

/**
 * Returns a sensible image URL for showing a product on a card.
 * Order of preference: streetwear[back-pattern] → streetwear[0] → front.
 */
export const getProductCardImage = (product) => {
  if (!product) return null;
  if (product.images?.streetwear?.length > 0) {
    const back = product.images.streetwear.find((img) => {
      const id = (img.publicId || img.url || '').toLowerCase();
      return /back|b1|gb_|ucb_|nrb_|kkb_/.test(id);
    });
    const target = back || product.images.streetwear[0];
    return resolveImageUrl(target?.url);
  }
  return resolveImageUrl(product.images?.front?.url);
};

/**
 * Returns all image URLs to preload when hovering over a card / opening PDP.
 */
export const collectProductImageUrls = (product) => {
  if (!product?.images) return [];
  const all = [
    product.images.front?.url,
    product.images.back?.url,
    product.images.closeup?.url,
    product.images.folded?.url,
    ...(product.images.streetwear || []).map((img) => img.url),
  ];
  return all.filter(Boolean).map(resolveImageUrl).filter(Boolean);
};
